<div odxLayout="flex vertical-center" class="w-100 error-text flex-column">
  <app-logo></app-logo>
  <h3 class="odx-title-3">{{ title }}</h3>
  @for (part of description; track part) {
    <p [innerHtml]="part"></p>
  }
  @if (showReloadButton) {
    <button odxButton (click)="reload()" i18n="@@app.fullScreenError.button.reloadPage">Seite neu laden</button>
  }
</div>
